import { render, staticRenderFns } from "./programUserPage.vue?vue&type=template&id=5b670dc2&scoped=true&"
import script from "./programUserPage.vue?vue&type=script&lang=js&"
export * from "./programUserPage.vue?vue&type=script&lang=js&"
import style0 from "./programUserPage.vue?vue&type=style&index=0&id=5b670dc2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b670dc2",
  null
  
)

export default component.exports